import { Line } from './Line.js'
import { Point } from './Point.js'
import { GEObject } from './GEObject.js'
export class AddLineTool extends GEObject {
	drawing = false
	line
	isActive = false
	constructor(editor) {
		super()
		this.editor = editor
		this.editor.canvas.addEventListener('mousedown',this.mousedown.bind(this))
		this.editor.canvas.addEventListener('mouseup', this.mouseup.bind(this));
		this.editor.canvas.addEventListener('mousemove', this.mousemove.bind(this));
	}
	activate(properties = {}) {
		this.line = null
		this.drawing = false
		this.isActive = true
		this.properties = properties
		this.trigger('isActive', this.isActive, properties)
	}
	deactivate() {
		this.line = null
		this.drawing = false
		this.isActive = false
		this.properties = null
		this.trigger('isActive', this.isActive)
	}
	mousedown(event) {
		if(!this.isActive) {
			return
		}
		if(this.line) {

			return
		}
		let x = event.offsetX * this.editor.getPixelRatio()
		let y = event.offsetY * this.editor.getPixelRatio()
		this.drawing = true;
		this.line = new Line(
			new Point(x, y), 
			new Point(x, y), 
			JSON.parse(JSON.stringify(this.properties))
		)
		this.line.setSelected(true)
	}
	mouseup(event) {
		if(!this.isActive) {
			return
		}
		if(!this.line) {
			return
		}
		if(this.line.getLength() < 10) {
			this.line = null
			this.trigger('render', null)
			return
		}
		this.drawing = false;
		let line = this.line
		this.line = null
		this.trigger('add', line)
	}
	mousemove(event) {
		if(!this.isActive) {
			return
		}
		if (!this.drawing) {
			return
		}
		if(!this.line) {
			return
		}
		let x = event.offsetX * this.editor.getPixelRatio()
		let y = event.offsetY * this.editor.getPixelRatio()
		this.line.setp2({ x: x, y: y })
		this.trigger('render', this.line)
	}
}